import { useTranslation } from 'next-i18next'

import {
  AppStoreIcon,
  AppStoreIconFr,
  BadgesContainer,
  FacebookIcon,
  InstagramIcon,
  KijijiCentralIcon,
  PlayStoreIcon,
  PlayStoreIconFr,
  SocialIcon,
  SocialIconsContainer,
  SocialsGroupB,
  StoreIconsContainer,
  TwitterIcon,
  YoutubeIcon,
} from '@/components/shared/global-footer/footer-badges/styled'
import { ROUTE_LOCALE, useLocale } from '@/hooks/useLocale'

export const FooterBadges = () => {
  const { routeLocale } = useLocale()
  const { t } = useTranslation('global_footer')
  const { t: tRoutes } = useTranslation('routes')

  return (
    <BadgesContainer>
      <StoreIconsContainer>
        <a
          aria-label={`${t('badges.app_store.label')}`}
          href={`${tRoutes('external.app_store.href')}`}
          rel="noreferrer noopener"
          target="_blank"
        >
          {routeLocale === ROUTE_LOCALE.en ? (
            <AppStoreIcon aria-hidden />
          ) : (
            <AppStoreIconFr aria-hidden />
          )}
        </a>
        <a
          aria-label={`${t('badges.google_play.label')}`}
          href={`${tRoutes('external.google_play.href')}`}
          rel="noreferrer noopener"
          target="_blank"
        >
          {routeLocale === ROUTE_LOCALE.en ? (
            <PlayStoreIcon aria-hidden />
          ) : (
            <PlayStoreIconFr aria-hidden />
          )}
        </a>
      </StoreIconsContainer>
      <SocialIconsContainer>
        <div>
          <SocialIcon
            $socialType="facebook"
            aria-label={`${t('badges.facebook.label')}`}
            href={`${tRoutes('external.facebook.href')}`}
            target="_blank"
            rel="noreferrer noopener nofollow"
          >
            <FacebookIcon aria-hidden />
          </SocialIcon>
          <SocialIcon
            $socialType="instagram"
            aria-label={`${t('badges.instagram.label')}`}
            href={`${tRoutes('external.instagram.href')}`}
            target="_blank"
            rel="noreferrer noopener nofollow"
          >
            <InstagramIcon aria-hidden />
          </SocialIcon>
          <SocialIcon
            $socialType="twitter"
            aria-label={`${t('badges.twitter.label')}`}
            href={`${tRoutes('external.twitter.href')}`}
            target="_blank"
            rel="noreferrer noopener nofollow"
          >
            <TwitterIcon aria-hidden />
          </SocialIcon>
        </div>
        <SocialsGroupB>
          <SocialIcon
            $socialType="kijijicentral"
            aria-label={`${t('badges.kijiji_central.label')}`}
            href={`${tRoutes('external.central_badge.href')}`}
            target="_blank"
            rel="noreferrer noopener"
          >
            <KijijiCentralIcon aria-hidden />
          </SocialIcon>
          <SocialIcon
            $socialType="youtube"
            aria-label={`${t('badges.youtube.label')}`}
            href={`${tRoutes('external.youtube.href')}`}
            target="_blank"
            rel="noreferrer noopener nofollow"
          >
            <YoutubeIcon aria-hidden />
          </SocialIcon>
        </SocialsGroupB>
      </SocialIconsContainer>
    </BadgesContainer>
  )
}
